import type { CrossLink } from 'types/navigation'

// Central registry of contextual internal links. Pages pick the relevant keys via getCrossLinks()
// so anchor text and descriptions stay consistent across the whole site (single source of truth).
const crossLinkByKey = {
  fonctionnalites: {
    href: '/fonctionnalites',
    iconName: 'ph:app-window-duotone',
    title: 'Découvrir les fonctionnalités du logiciel',
    description: 'Éditeur visuel, composition de diaporamas, planification et mise à jour à distance de tous vos écrans.',
    ctaLabel: 'Voir les fonctionnalités'
  },
  casUsages: {
    href: '/cas-usages',
    iconName: 'ph:buildings-duotone',
    title: 'Voir les cas d\'usages par secteur',
    description: 'Restaurants, commerces, cabinets, entreprises\u00A0: l\'affichage dynamique adapté à votre activité.',
    ctaLabel: 'Explorer les secteurs'
  },
  box: {
    href: '/box',
    iconName: 'ph:cube-duotone',
    title: 'Découvrir la box Live Display',
    description: 'Transformez n\'importe quel écran HDMI en écran connecté, prêt à diffuser en 5 minutes.',
    ctaLabel: 'Découvrir la box'
  },
  ecrans: {
    href: '/ecrans',
    iconName: 'ph:monitor-duotone',
    title: 'Explorer nos écrans professionnels',
    description: 'Murs d\'écrans, bornes tactiles et totems vidéo, fournis et posés partout en Suisse.',
    ctaLabel: 'Voir les écrans professionnels'
  },
  tarifs: {
    href: '/tarifs',
    iconName: 'ph:tag-duotone',
    title: 'Consulter les tarifs par écran',
    description: 'Une formule claire et sans engagement, facturée à l\'écran. Votre premier mois est offert.',
    ctaLabel: 'Voir les tarifs'
  },
  temoignages: {
    href: '/temoignages',
    iconName: 'ph:chat-circle-text-duotone',
    title: 'Lire les témoignages clients',
    description: 'Des établissements suisses racontent leur usage quotidien de Live Display.',
    ctaLabel: 'Lire les témoignages'
  },
  demo: {
    href: '/demo',
    iconName: 'ph:rocket-launch-duotone',
    title: 'Demander une démo gratuite',
    description: 'Testez Live Display sur vos écrans pendant un mois, sans engagement ni carte bancaire.',
    ctaLabel: 'Demander une démo'
  },
  devis: {
    href: '/devis',
    iconName: 'ph:calculator-duotone',
    title: 'Demander un devis personnalisé',
    description: 'Multi-sites, volume de box ou écrans professionnels\u00A0: obtenez une proposition adaptée à votre projet.',
    ctaLabel: 'Demander un devis'
  }
} satisfies Record<string, CrossLink>

export type CrossLinkKey = keyof typeof crossLinkByKey

export function getCrossLinks (keys: CrossLinkKey[]): CrossLink[] {
  return keys.map(key => crossLinkByKey[key])
}
